import React from "react";
import { Doughnut } from "react-chartjs-2";

import { Skeleton } from "antd";

const SignupPercent = ({ percentage, loading }) => {
	const options = {
		responsive: true,
		// aspectRatio: 0.1,
		maintainAspectRatio: false,
		legend: {
			position: "top",
			align: "center",
			display: false,
		},
		tooltips: {
			intersect: false,
		},
		scales: {
			yAxes: [
				{
					scaleLabel: {
						display: false,
					},
					ticks: {
						display: false, // it should work
					},
					gridLines: {
						display: false,
					},
				},
			],
		},
	};

	const data = {
		labels: ["가입자", "유입수"],
		datasets: [
			{
				// label: '댓글',
				data: [percentage?.signup ?? 0, percentage?.inflow ?? 0],
				borderColor: ["#117ffa", "#adb5bd"],
				backgroundColor: ["#117ffa", "#adb5bd"],
				// borderColor: ["#df1d1d", "#adb5bd"],
				// backgroundColor: ["#df1d1d", "#adb5bd"],
				borderWidth: 2,
			},
		],
	};

	return (
		<div
			className={`border-top`}
			style={{
				width: "100%",
				padding: "1.5em 0 0",
				display: "flex",
				flexDirection: "column",
				gap: "0.5em",
			}}
		>
			<h4>가입율</h4>

			<div
				style={{
					display: "flex",
					justifyContent: "space-evenly",
				}}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
						gap: "1.5em",
						width: "50%",
					}}
				>
					{loading ? (
						<>
							<Skeleton.Button
								loading={loading}
								active={loading}
								size={"large"}
								block={true}
								title={null}
								style={{
									margin: "auto",
									height: "2rem",
									width: "90%",
								}}
							/>
							<Skeleton.Button
								loading={loading}
								active={loading}
								size={"large"}
								block={true}
								title={null}
								style={{
									margin: "auto",
									height: "2rem",
									width: "90%",
								}}
							/>
						</>
					) : (
						<>
							<div className={`user-gender-div`}>
								<div
									className={`gender-point male`}
									style={{
										backgroundColor: "#adb5bd",
									}}
								/>
								<p style={{ fontSize: "1em", whiteSpace: "pre" }}>
									유입수 {percentage?.inflow?.toLocaleString()}회
								</p>
							</div>
							<div className={`user-gender-div`}>
								<div className={`gender-point male`} />
								<p style={{ fontSize: "1em", whiteSpace: "pre" }}>
									가입자 {percentage?.signup?.toLocaleString()}명
								</p>
							</div>
						</>
					)}
				</div>
				<div style={{ width: "47%", position: "relative", height: "15vh" }}>
					{loading ? (
						<Skeleton.Button
							loading={loading}
							active={loading}
							size={"large"}
							block={true}
							style={{
								height: "15vh",
							}}
							title={null}
						/>
					) : (
						<>
							<Doughnut options={options} data={data} />
							{!!percentage.inflow && (
								<p className={`doughnut-center-font`}>
									{((percentage?.signup / percentage.inflow) * 100).toFixed(1)}%
								</p>
							)}
						</>
					)}
				</div>
			</div>
		</div>
	);
};
export default SignupPercent;
